export default __webpack_public_path__ + "static/media/thank-you.87199bd5.svg";